<template>
  <v-dialog
    v-model="logsDialog"
    persistent
    width="500"
  >
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip
        top
        color="primary"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>mdi-file-download</v-icon>
          </v-btn>
        </template>
        <span>Log Files</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        Select log file to download
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="text-center"
            >
              <log-download-button
                v-if="server.server_type === 'WEB'"
                title="assyst"
                :log-file-data="logFileData.web"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'WEB'"
                title="smtp"
                :log-file-data="logFileData.smtp"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'WEB'"
                title="ace mobile"
                :log-file-data="logFileData.acemobile"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'WEB'"
                title="apm"
                :log-file-data="logFileData.webapm"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'WEB'"
                title="notifier"
                :log-file-data="logFileData.notifier"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'CSR' && server.chat === 'y'"
                title="chat"
                :log-file-data="logFileData.chat"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'CSR' && server.reports === 'y'"
                title="reports"
                :log-file-data="logFileData.reports"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'CSR' && server.search === 'y'"
                title="search"
                :log-file-data="logFileData.search"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'CSR' && server.reports === 'y'"
                title="apm"
                :log-file-data="logFileData.reportsapm"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'CSR' && server.assystai === 'y'"
                title="assyst ai"
                :log-file-data="logFileData.assystai"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'IMQ'"
                title="karaf"
                :log-file-data="logFileData.karaf"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'IMQ'"
                title="activemq"
                :log-file-data="logFileData.activemq"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'IMQ'"
                title="ipaas"
                :log-file-data="logFileData.ipaas"
                @selectLogFile="selectLogFile"
              />
              <log-download-button
                v-if="server.server_type === 'IMQ'"
                title="bridge"
                :log-file-data="logFileData.bridge"
                @selectLogFile="selectLogFile"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="logsDialog = false"
        >
          CANCEL
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { logFiles } from '@/util/assyst'
  export default {
    name: 'LogsDialog',
    props: {
      server: Object,
    },
    data () {
      return {
        logsDialog: false,
      }
    },
    computed: {
      logFileData () {
        return logFiles
      }
    },
    methods: {
      selectLogFile: function (data) {
        this.logsDialog = false
        this.$emit('downloadLogs', data.logpath, data.logfile)
      },
    },
  }
</script>
